import { Services } from './services';
import { CurrentState } from './state/page.state';

export const DRAGON_ID = 'c-id';
export const DRAGON_TYPE = 'c-type';
const SEARCH_LIMIT = 3;

export const DragonDomTypes = {
	TAG: 'tag',
	COLLECTION: 'collection',
};

export function findDragonNode(e) {
	var node = e.target;
	var count = 0;
	do {
		var key = node.getAttribute(DRAGON_ID);
		if (key != null) {
			return node;
		}
		node = node.parentNode;
	} while (node.parentNode != null && count < SEARCH_LIMIT);
}

var hoverTimeout = null;
var HOVER_TIMEOUT = 100;

export function handleMouseMove(e) {
	var node = findDragonNode(e);
	if (node != null) {
		var id = node.getAttribute(DRAGON_ID);
		Services.Window.window.clearTimeout(hoverTimeout);
		hoverTimeout = null;
		CurrentState.setHoverId(id);
	} else if (hoverTimeout == null) {
		if (CurrentState.hoverId == null) {
			return;
		}
		hoverTimeout = Services.Window.window.setTimeout((_) => {
			CurrentState.setHoverId(null);
			hoverTimeout = null;
		}, HOVER_TIMEOUT);
	}
}
